import Vue from "vue";
// require.context 是webpack的一个api
const req = require.context("./", true, /\.vue$/);
// 全局注册
req.keys().forEach((element) => {
  let name = element.replace(/(\.\/)|(\.vue)/gi, "");
  name = name.toLocaleLowerCase() + "-component";
  Vue.component(`${name}`, req(element).default);
});
